import axios from 'axios';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// import Backend from 'i18next-node-fs-backend';
// import Backend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  //   .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      en: {
        translation: {
          'Welcome to React': 'Welcome to React and react-i18next',
          headerMenu: {
            Solutions: 'Solutions',
            Industries: 'Industries',
            Products: 'Products',
            Pricing: 'Priсing',
            WhiteLabel: 'White Label',
            Support: 'Support',
            Sign_in: 'Sign in',
            Create_AR: 'Create AR',
            Blog: 'Media and Blogs',
            Scanner: 'AR Scanner',
            Editor: 'AR Editor',
            Gallery: 'Gallery',
            UserGuide: 'ROAR AR User Guide'
          },
          footerMenu: {
            About_ROAR: 'About ROAR',
            Industries: 'Industries',
            Products: 'Products',
            Pricing: 'Priсing',
            White_Label: 'White Label',
            Customers: 'Customers',
            Partners: 'Partners',
            Blog: 'Media and Blogs',

            Legal: 'Legal',
            Terms_of_use: 'Terms of use',
            Privacy_Policy: 'Privacy Policy',
            Refund_Policy: 'Cancellation Policy',

            Sales: 'Sales',
            Contact_us: 'Contact us',
            Request_a_Demo: 'Request a Demo',
            Download: 'Download',

            Follo_Us: 'Follow us'
          },
          homePage: {
            titleBlock: {
              title:
                'Scalable Cloud based SaaS Augmented Reality Content Creation Platform for Your Brand',
              button: 'Get Started',
              free_trial: 'Free Trial',
              contact_us: 'Contact us'
            },
            clientsBlock: {
              title: 'Brands that ROAR'
            },
            aboutBlock: {
              whatTitle: 'What is ROAR AR',
              whatDescr:
                'Augmented Reality Content Management platform that overlays real world objects with digitally immersive information. With ROAR you can augment real world with videos, sound, 2d and 3d graphic models, animations, gamification and much more.',
              whyTitle: 'Why ROAR AR',
              whyDescr:
                'ROAR is built to enable the creation of AR for small and large enterprise in a simple automated way.',
              whyButton: 'ROAR has image recognition quality over competitors',
              revenue: 'Increased revenue from users',
              costs: 'Reduced operational costs',
              newUsers: 'Acquiring new users',
              retention: 'Improving your customer retention'
            },
            stepsBlock: {
              title:
                'Create AR Content and Experience in just 3 Steps within 3 minutes',
              stepOneTitle: 'Create',
              stepOne: 'Create and Edit the Marker (image) to Augment ',
              stepTwoTitle: 'Edit',
              stepTwo:
                'Edit the Image/Object with Augmented content - Attach the various types of Augmented content like 2d or 3d models, video, buttons and more to the Marker',
              stepThreeTitle: 'Publish',
              stepThree:
                'Publish ROAR - Simply Publish the AR experience across all the platforms - iOS, Android and Web',
              stepFourTitle: 'View',
              stepFour:
                'View ROAR - Use ROAR Scanner to view the AR experience',
              button: 'Create AR Now'
            },
            casesBlock: {
              title: 'Use Cases',
              retailandbrands: {
                title: 'Retail and Brands',
                description: 'ROAR for Retail and Brands',
                list: {
                  1: 'Create innovative, immersive digital Augmented Reality content cost efficiently.',
                  2: 'Scale digital AR content using ROAR and engage your consumers in a more innovative way',
                  3: 'Build many AR experiences and publish multiple times across different platforms and channels without relying on technical skills',
                  4: 'Track the user engagement analytics to derive valuable insights for your business'
                },
                button: 'Create AR'
              },
              education: {
                title: 'Education',
                description: 'ROAR for Learning and Education',
                list: {
                  1: 'Embed Augmented Reality content into your projects, books, events and lessons',
                  2: 'Create digital training materials with Augmented reality content and innovate your training programs',
                  3: 'Gamify learning experience by creating interactive games: geo-location, treasure hunts, quiz and much more',
                  4: 'Educators can develop educational resources for classroom to provide digitally immersive, engaging content and interactions for students'
                },
                button: 'Create AR'
              },
              packaging: {
                title: 'Packaging',
                description: 'ROAR for Packaging',
                list: {
                  1: 'Create connected package and integrate Augmented reality to enhance standard package with digital product information & brand-specific marketing',
                  2: 'Embed special promotions and retail driven messages into packages to impact consumers’ purchasing decisions',
                  3: 'Excite your consumer through immersive and interactive gamification AR experience built into the package',
                  4: 'Integrate AR content to drive social responsibility such as education on use of plastics and recycling.'
                },
                button: 'Create AR'
              },
              automotive: {
                title: 'Automotive',
                description: 'ROAR for Automotive industry',
                list: {
                  1: 'Create AR Shopping assistance and demonstrate vehicles through immersive experience connecting your consumers with your real inventory',
                  2: 'Enable buyers to explore to interact with the car in the immersive way through Augmented Reality and create gamification for car pick up process',
                  3: 'Embed digital interactive step by step AR experience into operating manuals to enable more efficient diagnostic and repair process ',
                  4: 'Enhance training and learning materials for automotive engineering, assembly, sales and other employees with AR content to improve technical understanding and implement intuitive and easy to learn training materials'
                },
                button: 'Create AR'
              },
              entertainment: {
                title: 'Entertainment',
                description: 'ROAR for Entertainment',
                list: {
                  1: 'Innovate with digitally immersive entertainment content ranging from augmenting posters and events to creating interactive games',
                  2: 'Augment music, art, sport and other events with additional immersive digital content that enhances live event and allows watchers to become participants',
                  3: 'Enhance physical galleries, museums and other places of interest with digital content that entices your audience and enables you to build new community of followers for your content',
                  4: 'Create Augmented Reality at museums, tourist and hospitality sites, and entertainment centers and engage your audience digitally'
                },
                button: 'Create AR'
              },
              realestate: {
                title: 'Real Estate',
                description: 'ROAR for Real Estate',
                list: {
                  1: 'Implement Augmented Reality to drive higher sales and reach higher number of potential buyers for smarter “buy” decisions.',
                  2: 'Change the game for your sales process and allow potential buyers to experience a home through augmented reality immersive walkthrough and better filter out homes they like, saving agents time',
                  3: 'Create Augmented Reality for various potential landscape and real estate layouts and let the customer decide on what best layout works for them',
                  4: 'Builders can show prospective buyers what the end product will be, adding a concrete level of tangibility and increasing the ability to pre-sell projects'
                },
                button: 'Create AR'
              },
              museumsandart: {
                title: 'Museums and Art',
                description: 'ROAR for Museums and Entertaiment Centers',
                list: {
                  1: 'Augment paintings, collectibles and more with detailed and exciting information via digital AR experience and allow them to immerse into ART',
                  2: 'Enhance customer experience at the Points of Interest to include new level of digital content',
                  3: 'Educate the visitors with more historical information and the vision behind the showcasing the objects in the museum.'
                },
                button: 'Create AR'
              },
              healthcare: {
                title: 'Healthcare',
                description: 'ROAR for Health and Pharmaceutical industry',
                list: {
                  1: 'Enable AR for patients to see how the medication works in 3D in front of their eyes instead of reading long descriptions on the bottles or medication leaflets.',
                  2: 'Create new immersive way for Lab workers could monitor experiments with equipment enabled with augmented reality',
                  3: 'In pharmaceutical setting, enable workers to start working without hands on trainings by creating digital AR training and operational guides',
                  4: 'Enhance creation of digital content that allows consumers to experience and learn more about medical procedures'
                },
                button: 'Create AR'
              },
              machinery: {
                title: 'Machinery',
                description: 'ROAR for Machinery and Heavy Equipment industry',
                list: {
                  1: 'Create Augmented Reality content for heavy machinery to present at the trade shows without moving heavy equipment.',
                  2: 'Implement a real-world view of their projects, capturing a picture of the jobsite and superimpose a 3D model of the design',
                  3: 'Embed AR for live support in repairing, troubleshooting a problem or conducting maintenance on equipment',
                  4: 'Design digitally enhanced, easy to understand and immersive heavy machinery operating manuals'
                },
                button: 'Create AR'
              }
            },
            featuresBlock: {
              title: 'ROAR Types',
              button: 'Try for free',
              images: {
                title: 'Image Markers',
                description: 'Image Markers',
                list: {
                  1: 'Use AR-markers to create visual cues which will trigger the display of the augmented digital information.',
                  2: 'Leverage normal images or small objects and train so that they can be recognized later in the camera stream.',
                  3: 'Support both Android and IOS',
                  4: 'Create AR marker once and change digital AR content multiple times.'
                }
              },
              arkit: {
                title: 'ARKit & ARCore',
                description: 'ARKit & ARCore',
                formattedDescription: {
                  header1: 'Beta – ARKit SDK integration',
                  para1:
                    'ROAR leverages Apple’s machine learning framework ARKit to identify objects in a scene to enable users to create augmented reality without markers.',
                  header2: 'Coming Soon – ARCore SDK Integration',
                  para2:
                    'ROAR utilizes ARCore, marker-less technology, to anchor objects so that they appear augmented in its proper place',
                  para3:
                    'SLAM, simultaneous localization and mapping, which is embedded into both ARCore and ARKit allows environment charting and tracking, necessary for the real-time rendering of Augmented Experiences'
                }
              },
              webar: {
                title: 'WebAR (Beta)',
                description: 'WebAR (Beta testing)',
                list: {
                  1: 'ROAR leverages web-tech to enable Web AR experiences.',
                  2: 'Web AR is a set of AR-enabled web pages, using Javascript to package and deploy computer vision libraries and AR creative.',
                  3: 'WebAR allows AR content creation and delivery without App.'
                }
              },
              facebook: {
                title: 'Facebook Post',
                description: 'Facebook Post',
                list: {
                  1: 'Augment your facebook feed. Create stunning posts with Augmented Reality'
                }
              },
              gamification: {
                title: 'Gamification',
                description: 'Gamification (Coming Soon)',
                list: {
                  1: 'Gamify your AR experience with treasure hunt and exploration type location-based games.',
                  2: 'Leverage mini-games and -reskinning options to create your game or even a treasure hunt.',
                  3: 'Use templates for creating AR gaming experience and deliver fun to your customers.'
                }
              },
              object_tracking: {
                title: 'Object Tracking',
                description: 'Object Tracking',
                list: {
                  1: 'Currently in research and development.'
                }
              },
              face_tracking: {
                title: 'Face Recognition (Beta)',
                description: 'Face Recognition (Beta testing)',
                list: {
                  1: 'Beta testing in progress'
                }
              }
            },
            whyRoar: {
              title: 'Why ROAR',
              subtitleWithout: 'Without ROAR',
              subtitleWith: 'With ROAR',
              button: 'Create AR Now'
            },
            strengths: {
              title: 'Why ROAR',
              withoutRoar: {
                title: 'Without ROAR',
                itemOne: 'Team of Developers',
                itemTwo: 'Higher cost',
                itemThree: 'Takes more than 200 hours',
                itemFour: 'Dependence on developers'
              },
              withRoar: {
                title: 'With ROAR',
                itemOne: 'Non-Developers',
                itemTwo: 'Incredibly low cost',
                itemThree: 'Takes only minutes',
                itemFour: 'Independent'
              },
              numbersBlock: {
                title: 'ROAR by the Numbers',
                Users: 'Users',
                Scans: 'Scans',
                White_Label: 'White Label Customers',
                Industries: 'Industries',
                Experiences: 'ROAR Experiences created'
              }
            },
            subscribe: {
              title: 'Subscribe to our newsletters',
              descr: 'Sign-up to get news, updates and special offers',
              placeholder: 'Email',
              button: 'Subscribe'
            }
          },
          productsPage: {
            featuresBlock: {
              title: 'ROAR Platform Highlights',
              everyone: {
                title: 'Platform for Everyone',
                text1: 'AR Content Creator and Editor made easy.',
                text2: 'No coding, no technical skills required'
              },
              compatibility: {
                title: 'Platform Compatibility',
                text1:
                  'iOS, Android and Web. Supports all social media platforms.',
                text2: 'ARCore & ARKit enabled'
              },
              sas: {
                title: 'SAS - Available on Cloud',
                text1: 'Access anywhere with more than 99.99% uptime'
              },
              publishing: {
                title: 'Unlimited Publishing',
                text1: 'Create once publish many times.',
                text2: 'Access across different channels and technologies'
              },
              communitiesAndMarketplace: {
                title: 'Built for Communities and Marketplace',
                text1: 'Crowd Sourcing and Multi-User.',
                text2: 'Enables Crowd Sharing'
              },
              dataAnalytics: {
                title: 'AR Data Analytics',
                text1: 'Access to AR analytics via dashboard.',
                text2: 'Get data insights from your AR experiences'
              }
            },
            editorBlock: {
              title: 'ROAR Editor',
              tabTitleOne: '3D Models',
              tabTitleTwo: 'Photos, buttons, etc.',
              tabTitleThree: 'Video',
              linkPracing: 'Pricing',
              link: 'Try for Free',
              tabTextOne:
                'Create AR content in ROAR editor with simple drag and drop capability.Apply different content: video, images, button, text, 3D models and more.',
              tabTextTwo: 'About Photos, buttons, etc.',
              tabTextThree: 'About Video'
            },
            viewerBlock: {
              title: 'ROAR Scanner',
              text1: 'Use ROAR Scanner to view AR experience',
              text2: 'Available on IOS, Android and Web',
              textLink: 'Engage your customers with ROAR Scanner or your own',
              link: 'Branded WL Scanner',
              downloadText: 'Download app for free and try'
            },
            whiteLabel: {
              title: 'ROAR White Label',
              descr1:
                'Increase your customer loyalty through your own Branded AR Scanner app',
              descr2:
                'Leverage ROAR editor to create AR content, engage your own Branded App to deliver immersive AR content to your consumers',
              button: 'Create your App',
              stepText: 'Step 1/3',
              subtitle: 'Welcome Screen'
            },
            enterpriseBlock: {
              title: 'Enterprise SDK',
              descr1: 'Enable your branded AR Editor into your platform',
              descr2:
                'Embed AR CMS into your cloud environment and integrate with your security and data systems',
              button: 'Request Demo'
            },
            dataAnalytics: {
              title: 'ROAR Data Analytics',
              descr:
                'Integrate data analytics to measure impact of AR on your consumers – track user engagement, conversion, AR campaign effectiveness, and leverage data to drive improvements in your AR content',
              link: 'Get insight on your consumer engagement with AR content'
            }
          },
          supportPage: {
            title: 'Support',
            name: 'Your name *',
            email: 'Email *',
            country: 'Country',
            businessName: 'Business name (optional)',
            phoneNumber: 'Phone number (optional)',
            topic: {
              label: 'Select topic',
              New_inquiry: 'New product inquiry',
              Custom_solution: 'Custom solution',
              Partnership: 'Partnership',
              Tech_support: 'Tech support',
              Other: 'Other'
            },
            product: {
              label: 'Select product',
              Editor: 'Editor',
              IOS: 'IOS Viewer/Scanner',
              Android: 'Android Viewer/Scanner',
              White_Label: 'White Label Viewer/Scanner',
              Enterprise: 'Enterprise Viewer/Scanner SDK',
              Enterprise_Editor: 'Enterprise Editor SDK',
              Data_Analytics: 'Data Analytics',
              Other: 'Other'
            },
            message: 'Your message *',
            submitButton: 'Send'
          },
          whiteLabelPage: {
            titleBlock: {
              title: 'Build Your Own Branded App Today',
              link: 'Create App'
            },
            Augmented_Reality: {
              title:
                'Start using Augmented Reality Scanner with your own Brand',
              text1:
                'The White Label Scanner app provides businesses with the opportunity to deliver Augmented Reality functionality and features to their customers with their own Branded Scanner App.',
              text2:
                'Enable your customers to experience immersive AR content using iOS and Android devices.',
              text3:
                'Create your Branded White Label Augmented Reality Scanner app in just few steps.',
              text4:
                'Manage your AR content, make in public or private, share with your customers and colleagues'
            },
            processWork: {
              title: 'How does this process work?',
              delivery: {
                title: 'Delivery Date',
                descr:
                  'Check the available date when your WL Branded app will be ready and confirm the date.'
              },
              create: {
                title: 'Create',
                descr:
                  'Build your AR Branded Scanner through simple White Label online builder in 4 simple steps.'
              },
              pay: {
                title: 'Pay Secure',
                descr:
                  'Pay online via a secured gateway. Our team will package your app and will deliver your own Branded app to you in just few weeks or less.'
              },
              deploy: {
                title: 'Deploy',
                descr:
                  'Upload your builds into Google Play and App Store accounts. Your AR App is  ready and you can start using it!'
              }
            },
            appWork: {
              title: 'How does White Label App Work?',
              build:
                'Build Branded White Label Scanner App using ROAR White Label builder',
              create: 'Create and edit content in ROAR Editor',
              publish:
                'Publish your Branded White Label Scanner App in Google Play and Apple store',
              view:
                'Enable your customers to view your AR experiences using your own branded Scanner / Viewer'
            },
            brandedApps: {
              title: 'How will it look?',
              descr:
                'More than 10 mobile screens, including tutorial, AR scanner and many more… Get both apps for the major devices'
            },
            pricing: {
              title: 'Pricing',
              oneTimeFee: 'One time fee',
              priceInformation: 'for Price Information',
              date: 'Mon, 24 February 2020',
              deliveryTime: 'Target delivery time',
              dateDescr:
                'Final release date depends on the current demand and backlog. Delivery date may vary by 2-3 days.',
              estimatedDate:
                'Do you need your app earlier than the estimated date?',
              button: 'Request'
            },
            plans: {
              title: 'Select your cloud plan',
              descr:
                'Control AR content, make in public or private. Share with your friends and colleagues',
              text: 'Billed annually or month-to-month',
              views: 'Views',
              experiences: 'AR experiences',
              link: 'Contact Us'
            },
            contactUs: {
              title:
                'Interested in integrating ROAR into your existing business app?',
              text1:
                'If you have an existing mobile app and are interested in integrating Augmented Reality Viewer as a feature, we can enable that too. ROAR AR makes it easy to integrate Augmented Reality into your platform. Contact us here to get a quote for integrating AR Viewer functionality into your existing app.',
              text2:
                'If you are interested in custom solutions, including turnkey projects, custom UX/UI, 3D, animation or even apps for mixed reality smart glasses, Contact us here to discuss your requirements and get a quote.',
              form: {
                title: 'Contact our sales representative',
                name: 'Your name *',
                email: 'Email *',
                businessName: 'Business name',
                phoneNumber: 'Phone number',
                message: 'Describe your project *',
                submitButton: 'Send inquiry'
              }
            }
          },
          editorPage: {
            titleBlock: {
              title: 'Create Your Own Augmented Reality',
              button: 'Create AR'
            },
            createBlock: {
              title: 'Create Your Own Augmented Reality',
              button: 'Create AR'
            },
            contentBlock: {
              descr:
                'ROAR Editor is the best-in-class tool to create your own high quality Augmented Reality experience just in a couple of clicks. It is designed for non-technical users. Whether you need it for personal use or for business, ROAR will provide you the full set of AR features that will help you test, play and deliver totally immersive user experience for your customers, partners and friends. The ROAR Editor contains all major Augmented Reality features, including video, audio, action buttons (CTA), images, text, 3D models and even additional facts for your CPG products.',
              targetImg: {
                title: 'Target image (marker)',
                block1: {
                  descr:
                    'To explore an Augmented Reality experience, users need to scan the target image (marker) through iOS or Android app. So anyone who wants to create an AR, first needs to upload the target image (marker). The marker should be unique for each AR experience.It can be any printed material (image), for example:',
                  list: {
                    highlightText1: 'Part of the image',
                    descr1:
                      'a logo, ad in magazine, label, part of billboard or citylight',
                    highlightText2: 'Full image',
                    descr2:
                      'page of the magazine or newspaper, CPG (foods and beverages), post card or full image of billboard'
                  }
                },
                block2: {
                  descr:
                    'In addition, the marker can also be a static digital image, for example:',
                  list: {
                    descr1: 'Image on the website',
                    descr2: 'Static image or logo during TV advertising',
                    descr3: 'Digital catalogs, for example .pdf or .ppt',
                    descr4: 'Static image on DOOH'
                  },
                  text:
                    'You can use ROAR Editor templates to define proper marker for your Augmented Reality experience.'
                }
              },
              models: {
                title: '3D models',
                descr1:
                  'The ROAR Editor brings 3D models to life. You can easily drag & drop or upload your .zip archive with elements. Then you are able to set up additional settings such as width, height, rotation and more.',
                descr2:
                  'Please note that your 3D content needs to be prepared in proper format. ROAR platform supports formats as follows:',
                list: {
                  highlightText1: '*.obj',
                  descr1: 'for 3D model',
                  highlightText2: '*.png, *.jpg, *.tga',
                  descr2: 'for textures',
                  highlightText3: '*.mtl',
                  descr3: 'with all sets'
                },
                descr3:
                  'AR 3D models will visualize your architecture and 3D printing as well as differentiate your brand delivering WOW experiences.'
              },
              video: {
                title: 'Video',
                descr1:
                  'AR video can bring totally new user experience for your brand or business. The Editor makes it easy to use AR video content.',
                descr2:
                  'You can upload the video file from your hard drive or copy/paste YouTube* link. As a result, your AR video will be streamed from the cloud, playing directly on the target image',
                descr3:
                  'Additionally, you can use chromakey to create high quality video AR content.'
              },
              facts: {
                title: 'Facts for CPG',
                descr:
                  'ROAR platform is proud for its Facts feature that ideally fits for CPG brands (packaged food & drinks) across U.S. By using seamless integration of different third-party APIs and its aggregation on the platform, ROAR provides full capability of simply adding useful AR content to your experience. Just enter UPC code and different information including nutrition facts, reviews, pricing and nearby stores can be displayed directly on the product.'
              },
              actionBtns: {
                title: 'Action buttons (CTA)',
                descr:
                  'Call-to-action buttons based on Augmented Reality experience can open new benefits for users. They provide ability to redirect to your website or download a mobile app. In addition, they can be used to provide your customers an opportunity to book or buy your products. Use the ROAR button templates or upload your custom buttons just in one click.'
              },
              images: {
                title: 'Images',
                descr:
                  'AR images will help create deeper user experience with shadows or additional elements'
              },
              text: {
                title: 'Text',
                descr:
                  'ROAR Editor enables to enrich AR text with various parameters, such as size, weight, links, alignment and more'
              },
              audio: {
                title: 'Audio',
                descr:
                  'AR audio allows to create immersive sound effects and add voice or music'
              },
              builder: {
                title: 'AR builder for ARKit and ARCore',
                text1:
                  'ROAR presents Augmented Reality experiences based on Apple ARKit and Google ARCore technologies. This user-friendly Builder allows users to simply drag-and-drop their digital assets and create their own Augmented Reality experiences in a few clicks. ROAR allows you to use not only 3D models but to add digital assets such as: Videos (inc. chromakey and lumakey videos), Call-to-Action (CTA) buttons, Images, Text, Audio and sure 3D models and animations.',
                text2:
                  'These features make ROAR the most versatile Augmented Reality builders and editors on the market.',
                text3:
                  'your first AR experience based on ARKit and ARCore technologies.',
                link: 'Create now'
              },
              webAR: {
                title: 'WebAR',
                text:
                  'ROAR is rolling out new features surrounding WebAR technologies. We now enable the creation of WebAR experiences through our online web builder. In addition, ROAR allows you to mix different digital assets, like: Images, Text and 3D models. To discover WebAR experiences users are able to view the AR content in iOS Safari browser without downloading of mobile apps.',
                linkText1: 'Start to',
                linkText2: 'WebAR experiences right away with ROAR!',
                link: 'create your own '
              }
            }
          },
          scannerPage: {
            titleBlock: {
              title: 'Augmented Reality Scanner',
              button: 'Contact Us'
            },
            contentBlock: {
              text1:
                'ROAR Augmented Reality App is one of the best mobile apps with embedded AR scanner. An app was built using the native technologies such as Objective-C for iOS and Java for Android. These technologies provide huge native performance to ROAR, great user experience and intuitive user interface relevant to all mobile guidelines.',
              text2:
                'Download ROAR Augmented Reality App today to explore hundreds of different AR experiences in our Gallery and not only.',
              text3:
                'In addition, you can create your own Augmented Reality experience through our Editor. Then use ROAR App to test, discover and share your AR experience.',
              text4:
                'Another option that ROAR can provide is building a custom White Label app for you. We can create your own branded Augmented Reality Scanner based on existing features of ROAR scanner or make additional customization for you. Optionally, if you already have an existing app and are looking to integrate the AR scanner into your app, we can implement it.',
              text5:
                'Feel free to download our scanner to explore ROAR right away!'
            },
            downloadBlock: {
              title: 'Download The App'
            }
          },
          contactUsPage: {
            pageTitle: 'Contact Us',
            title: 'Fill the form to contact out sales representative',
            name: 'Your name *',
            businessName: 'Business name (optional)',
            email: 'Email *',
            phoneNumber: 'Phone number (optional)',
            message: 'Describe your project *',
            messageOptional: 'Describe your project (optional)',
            submitButton: 'Send inquiry',
            followUs: 'Follow us',
            subTitle: 'Tell us more about your project.',
            subTitleWith: 'Select options from the dropdowns below:',
            wantArForTitle: 'I want AR for',
            methodsArTitle: 'What method do you prefer for AR',
            appearWhenTitle: 'AR should appear when'
          },
          blogPage: {
            pageTitle: 'Media and Blog',
            readMore: 'Read more',
            watchNow: 'Watch Now'
          },
          refundPolicyPage: {
            title: 'Charges, Refund and Cancellation Policy'
          },
          privacyPolicyPage: {
            title: 'PRIVACY POLICY'
          },
          termsAndConditionsPage: {
            title: 'TERMS OF USE'
          },
          page404: {
            headTitle: '404: Not found',
            title: 'PAGE NOT FOUND',
            text: "You just hit a route that doesn't exist... the sadness."
          },
          validations: {
            email: {
              required: 'Email is required',
              invalid: 'Email must be a valid email'
            },
            password: {
              required: 'Password is required',
              min: 'Password must be at least 8 characters',
              match: 'Passwords do not match'
            },
            named_field: {
              required: 'is required',
              invalid: 'is invalid',
              min: 'must be at least 8 characters'
            }
          },
          emailCapture: {
            title: 'Keep In Touch',
            text: 'Sign-up to receive special offers, news and updates',
            input: 'Your email',
            cancelButton: 'No thanks',
            submitButton: 'Submit',
            thankYou: 'Thank you!'
          }
        }
      },
      ru: {
        translation: {
          'Welcome to React': 'Добро пожаловать'
        }
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    backend: axios,

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
